var React = require('react');

function AppliancesMicrowave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m109.5 94.5004h-90c-1.657 0-3-1.344-3-3v-60c0-1.657 1.343-3 3-3h90c1.657 0 3 1.343 3 3v60c0 1.656-1.343 3-3 3zm-81-12.0004h60v-42h-60zm60-53.9996v66m0-17.2216c-5.675-1.27-10-7.851-10-15.778 0-7.929 4.325-14.51 10-15.78m6 .7792h12v-12h-12zm11 15.0004c0 2.762-2.239 5-5 5s-5-2.238-5-5 2.239-5 5-5 5 2.238 5 5zm-11 26.9996h12v-6h-12zm-72 11.0004h16m52 0h16","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}));
}

AppliancesMicrowave.defaultProps = {"height":"128","viewBox":"0 0 128 128","width":"128"};

module.exports = AppliancesMicrowave;

AppliancesMicrowave.default = AppliancesMicrowave;
